// extracted by mini-css-extract-plugin
export default {"table":"OrdersPage_table__dFqwn"};